<div
  class="picker"
  [class.picker--small]="size === 'small'"
  [class.picker--normal]="size === 'normal'"
  [class.picker--large]="size === 'large'"
  [style.background]="backgroundCSS"
  [colorPicker]="colorHex"
  [cpAlphaChannel]="alphaEnabled ? 'always' : 'disabled'"
  [cpOutputFormat]="'hex'"
  (colorPickerChange)="handleColorPickerChange($event)"></div>
